export { default } from "./ProductSpotlight";
